import { render } from "./Sales.vue?vue&type=template&id=11f4b44c"
import script from "./Sales.vue?vue&type=script&lang=js"
export * from "./Sales.vue?vue&type=script&lang=js"

import "./Sales.vue?vue&type=style&index=0&id=11f4b44c&lang=css"
script.render = render

export default script